import {createSlice} from '@reduxjs/toolkit';

const ChooseCellularServicesSlice = createSlice({
  name: 'chooseCellularServices',
  initialState: {
    isCellularServicesOpt1Changed: false,
    isCellularServicesOpt2Changed: false,
    isCellularServicesOpt3Changed: false,
    isCellularServicesOpt4Changed: false,
    isCellularServicesOpt5Changed: false,



    isCellularServicesOpt1: false,
    isCellularServicesOpt2: false,
    isCellularServicesOpt3: false,
    isCellularServicesOpt4: true,
    isCellularServicesOpt5: false,

    ZOT_DOWN_CON_IND : false,
    ZOT_VOTE_IND: false,
    ZOT_DONATE_IND: false,
    ZOT_REC_CONT_IND: false,
    ZCN_DOWN_CON_IND: false,
    ZCN_REC_CONT_IND: false,
    ZOT_INFO_IND: false,
    PREMIUM0_IND: false,
    PREMIUM1_IND: false,
    INTL_IND: true,
    B144_IND: false,
  },

  reducers: {
    initDataCellularServices: (state, action) => {
          state.isCellularServicesOpt1Changed = false;
          state.isCellularServicesOpt2Changed = false;
          state.isCellularServicesOpt3Changed = false;
          state.isCellularServicesOpt4Changed = false;
          state.isCellularServicesOpt5Changed = false;

          state.isCellularServicesOpt1 =  false;
          state.isCellularServicesOpt2 =  false;
          state.isCellularServicesOpt3 =  false;
          state.isCellularServicesOpt4 = true;
          state.isCellularServicesOpt5 = false;

          state.ZOT_DOWN_CON_IND =  false;
          state.ZOT_VOTE_IND =  false;
          state.ZOT_DONATE_IND =  false;
          state.ZOT_REC_CONT_IND =  false;
          state.ZCN_DOWN_CON_IND =  false;
          state.ZCN_REC_CONT_IND =  false;
          state.ZOT_INFO_IND =  false;
          state.PREMIUM0_IND =  false;
          state.PREMIUM1_IND =  false;
          state.INTL_IND = true;
          state.B144_IND = false;

      },
      onCloseCellularServices: (state, action) => {

            if(state.isCellularServicesOpt1Changed){
              state.isCellularServicesOpt1 = !state.isCellularServicesOpt1;
            }
            if(state.isCellularServicesOpt2Changed){
              state.isCellularServicesOpt2 = !state.isCellularServicesOpt2;
            }
            if(state.isCellularServicesOpt3Changed){
              state.isCellularServicesOpt3 = !state.isCellularServicesOpt3;
            }
            if(state.isCellularServicesOpt4Changed){
              state.isCellularServicesOpt4 = !state.isCellularServicesOpt4;
            }
            if(state.isCellularServicesOpt5Changed){
              state.isCellularServicesOpt5 = !state.isCellularServicesOpt5;
            }

            state.isCellularServicesOpt1Changed = false;
            state.isCellularServicesOpt2Changed = false;
            state.isCellularServicesOpt3Changed = false;
            state.isCellularServicesOpt4Changed = false;
            state.isCellularServicesOpt5Changed = false;
        
      },
      setCellularServicesOpt1: (state, action) => {
        state.isCellularServicesOpt1Changed = true;
        state.isCellularServicesOpt1 = action.payload;
      },
      setCellularServicesOpt2: (state, action) => {
        state.isCellularServicesOpt2Changed = true;
        state.isCellularServicesOpt2 = action.payload;    
      },
      setCellularServicesOpt3: (state, action) => {
          state.isCellularServicesOpt3Changed = true;
          state.isCellularServicesOpt3 = action.payload;  
      },
      setCellularServicesOpt4: (state, action) => {
        state.isCellularServicesOpt4Changed = true;
        state.isCellularServicesOpt4 = action.payload;
      },
      setCellularServicesOpt5: (state, action) => {
        state.isCellularServicesOpt5Changed = true;
        state.isCellularServicesOpt5 = action.payload;
      },
      savedCellularServices: (state, action) => {
        state.isCellularServicesOpt1Changed = false;
        state.isCellularServicesOpt2Changed = false;
        state.isCellularServicesOpt3Changed = false;
        state.isCellularServicesOpt4Changed = false;
        state.isCellularServicesOpt5Changed = false;

        state.ZOT_VOTE_IND = state.isCellularServicesOpt1;
        state.ZOT_DONATE_IND = state.isCellularServicesOpt1;
        state.ZOT_REC_CONT_IND = state.isCellularServicesOpt1;
        state.ZOT_INFO_IND = state.isCellularServicesOpt1;
        state.ZOT_DOWN_CON_IND = state.isCellularServicesOpt1;

        state.ZCN_DOWN_CON_IND = state.isCellularServicesOpt2;
        state.ZCN_REC_CONT_IND = state.isCellularServicesOpt2;

        state.PREMIUM0_IND = state.isCellularServicesOpt3;    
        state.PREMIUM1_IND = state.isCellularServicesOpt3;

        state.INTL_IND = state.isCellularServicesOpt4;

        state.B144_IND = state.isCellularServicesOpt5;
      },
  },
});

export const {setCellularServicesOpt1, setCellularServicesOpt2, setCellularServicesOpt3 , setCellularServicesOpt4, setCellularServicesOpt5 , initDataCellularServices, savedCellularServices, onCloseCellularServices} = ChooseCellularServicesSlice.actions;

export default ChooseCellularServicesSlice.reducer;
